import api_config from '../config/api'

export default {
	getWhyEdim(lang) {
		return api_config.get(`api/why_edim/${lang}`)
	},
}
